<template>
<div>
    <h3 class="font-weight-regular mb-3 submenu-title">{{$t('zargeGegenBandseite')}}</h3>
    <!-- E komentuar pasi qe nuk ka pasur nevoje per dependency sepse description eshte dashur te jete e nejejt -->
    <!-- <div class="body-2 lighter-text">{{ getRegisteredCharacteristicsValue("CUST_MM_ZARGE_ART", frameContext).value.description }} -->
    <div class="body-2 violet-text">{{ getRegisteredCharacteristicsValue("KTU_MM_ZARGEN_KURZFORM", frameContext).value.description }}
    </div>
    <v-row>
            <v-col cols="6">
                <div class="subtitle-2 mb-2">{{$t('zargenOberflache')}}</div>
                <v-select 
                    dense 
                    outlined 
                    return-object 
                    :menu-props="{ offsetY: true }"
                    :items="frameSurfaceCharacteristicsDropdown" item-text="description"
                    :value="getRegisteredCharacteristicsValue('CUST_MM_ZARGE_OBERFL_GBS_N', doorLeafSurfaceContext).value"
                    @change="handleFrameSurfaceOptionSelect($event);">
                </v-select>

                <div class="body-2 pb-2" style="">
                    {{ $t('sonderlackierung') }}</div>
                <v-text-field  v-model="specialDecor"  :disabled="!frameInputEnabled" dense outlined hide-details >
                </v-text-field>
               
            </v-col>
            <v-col cols="6">
                <div class="subtitle-2 mb-2">{{$t('anschlagdichtung')}}</div>
                <v-select 
                    dense 
                    outlined 
                    return-object 
                    :menu-props="{ offsetY: true }"
                    :items="stopSealCharacteristicsDropdown" item-text="description"
                    :value="getRegisteredCharacteristicsValue('CUST_MM_Z_DICHTUNG', doorLeafSurfaceContext).value"
                    @change="handleStopSealOptionSelect($event)">
                </v-select>
               
            </v-col>
        </v-row>
</div>
    <!-- <div>
        <h1 class="title">Zarge GegenBandseite</h1>
        <label class="input-label">{{ getRegisteredCharacteristicsValue("CUST_MM_ZARGE_ART", doorLeafSurfaceContext).value.description }}</label>
        <div class="zarge-wrap">
            <label class="input-label">Zargen Oberfläche</label>
            <div class="full-dropdown">
                <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle dropdown-button"
                            type="button" id="dropdownMenuButton" data-toggle="dropdown"
                            aria-haspopup="true" aria-expanded="false">{{ getRegisteredCharacteristicsValue("KTU_MM_ZARGE_OBERFL_GBS", doorLeafSurfaceContext).value.description }}<span></span>
                        </button>
                        <div class="dropdown-menu open-top" aria-labelledby="dropdownMenuButton">
                            <div class="simplebar" data-simplebar>
                                <a v-for="(valueDefinition, index) in frameSurfaceCharacteristicsDropdown" :key="index"
                                @click.prevent="handleFrameSurfaceOptionSelect(valueDefinition);" 
                                class="dropdown-item" href="#">{{valueDefinition.description}} </a>
                            </div> 
                        </div>
                </div>
            </div>
            
            <div :class="{'input-group' : true, 'disabled' : !frameInputEnabled}">
                <div class="input-group-prepend">
                    <span class="input-group-text" id="inputGroup-sizing-default">Sonderlackierung / RAL Farbe / angeben  </span>
                </div>
                <input type="text" class="form-control" v-model="specialDecor" aria-label="Default" :disabled="!frameInputEnabled"
                    aria-describedby="inputGroup-sizing-default" value="">
            </div>

           <label class="input-label">Anschlagdichtung</label>
           <div class="full-dropdown">
                <div class="dropdown">
                    <button class="btn btn-secondary dropdown-toggle dropdown-button"
                        type="button" id="dropdownMenuButton" data-toggle="dropdown"
                        aria-haspopup="true" aria-expanded="false">{{ getRegisteredCharacteristicsValue("CUST_MM_Z_DICHTUNG", doorLeafSurfaceContext).value.description }}<span></span>
                    </button>
                    <div class="dropdown-menu open-top" aria-labelledby="dropdownMenuButton">
                        <div class="simplebar" data-simplebar>
                            <div>
                                <a v-for="(valueDefinition, index) in stopSealCharacteristicsDropdown" :key="index"
                                @click.prevent="handleStopSealOptionSelect(valueDefinition);" 
                                class="dropdown-item" href="#">{{valueDefinition.description}} </a>
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
            <label class="input-label"><b>Oberfläche: {{ getRegisteredCharacteristicsValue("CUST_MM_OBERFLACHE_TXT", doorLeafSurfaceContext).value.description }}</b></label>
            <label class="input-label">{{ getRegisteredCharacteristicsValue("KTU_MM_ZARGE_OBERFL_GBS", doorLeafSurfaceContext).value.description }}</label>
        </div> 
    </div> -->
</template>
<script>
    import Vue from 'vue';  
    import { mapGetters } from 'vuex';
    import { mapActions } from 'vuex';       
    import { DoorConfiguration } from '../../../configurator/DoorConfiguration';
    
    export default Vue.extend({
        name: 'FrameSurfaceCounterOpeningSide',        
        props: {
            characteristic: Object,            
        },
        data() {
            return {
                doorLeafSurfaceContext : DoorConfiguration.DoorLeafSurface,
                frameContext: DoorConfiguration.Frame,
                frameSurfaceCharacteristicsDropdown : [],
                stopSealCharacteristicsDropdown : [],
                frameInputEnabled : false,
                specialDecorValue : '',
            }
        },
        computed: {            
             ...mapGetters('configuratorModule',['getCurrentDoorConfiguration','getRegisteredCharacteristicsValue','getBlankCharacteristic']),
             ...mapGetters('doorLeafSurfaceModule', [ 'getCharacteristicAndValues', 'getNrOfValuesByCharacteristic', 'checkRadioValue' ]),
           specialDecor : {
                 //getter
                get: function () {
                    
                    if(parseInt(this.getRegisteredCharacteristicsValue('KTU_MM_ZARGE_OBERFL_SOND_GBS', this.doorLeafSurfaceContext).value.value) == 0)
                    {
                        this.specialDecorValue = '';
                    }else {
                        this.specialDecorValue = this.getRegisteredCharacteristicsValue('KTU_MM_ZARGE_OBERFL_SOND_GBS', this.doorLeafSurfaceContext).value.value
                    }
                     
                    return this.specialDecorValue;
                },
                //setter
                set : function(newValue )  {
                    this.valueAddCharacteristic({ characteristicValue: this.getCharacteristicAndValues('KTU_MM_ZARGE_OBERFL_SOND_GBS'), value: newValue });
                    this.specialDecorValue = newValue;

                    this.setAProfileSOAndWinkelSO();
                    this.setFutterplOberfl();
                }
            },
        },
        methods: {
                ...mapActions('configuratorModule',['updateDoorConfiguration']),
                ...mapActions('doorLeafSurfaceModule', ['addCharacterisitc','valueAddCharacteristic','setNormalDichtungCharacteristic','setAProfilAndAWinkel', 
                    'calculateDoorLeafSurfaceZargeGBS','setAProfileSOAndWinkelSO','setFutterplOberfl']),
                handleFrameSurfaceOptionSelect(valueDefinition) {
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues("CUST_MM_ZARGE_OBERFL_GBS_N"), valueDefinition: valueDefinition });
                    this.calculateDoorLeafSurfaceZargeGBS();
                    this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', "KTU_MM_FUTTERPLATTE_S");
                    this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', "KTU_MM_FUTTERPLATTE_W");
                    this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', "KTU_MM_FUTTERPL_OBERFL");
                    this.setAProfilAndAWinkel();

                    if(valueDefinition.value === '12') {
                    this.frameInputEnabled = true;
                    }else {
                        this.specialDecor = '';
                        this.frameInputEnabled = false;
                    }
                },
                handleStopSealOptionSelect(valueDefinition) {
                    this.addCharacterisitc({ characteristic: this.getCharacteristicAndValues("CUST_MM_Z_DICHTUNG"), valueDefinition: valueDefinition });
                    this.$store.dispatch('doorLeafSurfaceModule/setCharacteristicDependencies', "KTU_MM_Z_DICHTUNG");
                    //KTU_MM_DICHTUNG
                    this.setNormalDichtungCharacteristic();
                }
            },
            mounted() {
                this.frameSurfaceCharacteristicsDropdown = this.getCharacteristicAndValues("CUST_MM_ZARGE_OBERFL_GBS_N", this.doorLeafSurfaceContext).values;
                this.stopSealCharacteristicsDropdown = this.getCharacteristicAndValues("CUST_MM_Z_DICHTUNG", this.doorLeafSurfaceContext).values;
                this.handleFrameSurfaceOptionSelect(this.getRegisteredCharacteristicsValue('CUST_MM_ZARGE_OBERFL_GBS_N', this.doorLeafSurfaceContext).value);
                //this.setNormalDichtungCharacteristic();
                //this.setAProfilAndAWinkel();
            }
    });
</script>
<style scoped>

</style>